import { render, staticRenderFns } from "./NoticeDataTable.vue?vue&type=template&id=53313cab&scoped=true&"
import script from "./NoticeDataTable.vue?vue&type=script&lang=js&"
export * from "./NoticeDataTable.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDataTable.vue?vue&type=style&index=0&id=53313cab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53313cab",
  null
  
)

export default component.exports